import { Col, Row } from "react-bootstrap";
import { FaDownload, FaEye, FaFilePdf } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ACADEMIC_YEAR, CONTEXT_HEADING, CONTEXT_NAME } from "../CommonUtilities/Validations/RegularExpAndVar";
import React from "react";
export default function DashboardHome() {

  const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails);
  const hasResultsAccess = loginreducer?.roleServices?.some(val => val?.target === '/Results');
  //  console.log("Has access to /Results:", hasResultsAccess);

  let navigate = useNavigate()
  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      {/* {hasResultsAccess ? 
        <Row className=""><Col md={2}></Col>
        <Col md={8} className="text-error text-center mb-2">
          <h5 className="mt-2" style={{ color: "black" }}> Dear <span style={{ color: "brown" }}>  {loginreducer?.loginData?.applicant_name}</span>,
           <button type="button" onClick={() => {  navigate('/Results'); }}  className="btn btn-link btn-sm">
                👉 Click here</button>to View Your MEGA DSC-2025 Score Card.
          </h5><br/><br/>
           <h6><span className="text-danger"> Note : If you have any objections regarding your TET highest score <br/>
              <button type="button" onClick={() => { navigate('/TetObjections') }} className="btn btn-link btn-sm">
                👉 Click here</button> to provide your correct TET highest score details.</span>
              <button className="btn btn-link btn-sm" type="button" onClick={() => {
                window.open(`${process.env.PUBLIC_URL}/DSC-PDF/UserManuals/DSC Results User Manual.pdf`, '_blank');
              }}> <FaFilePdf />User Manual</button> </h6>
        </Col><Col md={2}></Col> </Row>: */}
      <div className="text-center">
        <h1 className="display-4 text-dark fw-bold">Welcome to {CONTEXT_NAME} {ACADEMIC_YEAR}</h1>
        <p className="lead mt-3">Department of School Education, Andhra Pradesh</p>
        {/* {hasResultsAccess &&
          (<>
          <strong className="text-danger">Mega DSC-2025 Web Options will be closed by 2:00 PM on 10-10-2025</strong><br />
            <button className="btn btn-success py-2" type="button" onClick={() => { navigate('/FinalWebOptions') }}>Click Here to Choose WebOptions</button>
          <h3 className="pt-3"><img src="../img/new2.gif" style={{height:"30px"}} className="img-fluid" alt="new" /><span className="text-danger">
           MEGA DSC 2025 Web Options - Schools Opened.</span></h3>
          </>)
        } */}

         {/* {hasResultsAccess &&
          (<> <button className="btn btn-success py-2" type="button" onClick={() => { navigate('/Results') }}>Click Here to <FaEye/> MarksMemo</button>
          <h3 className="pt-3"><img src="../img/new2.gif" style={{height:"30px"}} className="img-fluid" alt="new" /><span className="text-danger">
           AP TET 2025 MarksMemo Released.</span></h3>
          </>)
        } */}
      </div>
      {/* } */}

    </div>
  )
}
